import axios from 'axios';
import * as Config from '../../config';

const state = {

};

const actions = {
    study_engagementCenterPanel() {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'study/engagement-center-panel')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    study_get_monos({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'study/get-monos/' + form.id_study)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    get_Studies({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'study/list/all')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    panel_Messages({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'study/' + form.idStudy + '/panel/messages')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    send_Message({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mono/' + form.idStudy + '/send-message-informe', form.data)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    send_MessageMany({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mono/' + form.idStudy + '/send-message-informe-many', { data: form.data })
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    send_message_recategorizacion({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'study/' + form.idStudy + '/send-message-recategorizacion', form.data)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    study_get_ventana_recategorizacion() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'study/get-ventana-recategorizacion/')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    study_update_ventana_recategorizacion({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'study/update-ventana-recategorizacion/', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    study_updtae_mono_nota({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'study/update-mono-nota/', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    study_getFormFile({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios({
                url: Config.apiPath + 'study/get-form-file',
                method: 'POST',
                data: form,
                responseType: 'blob'
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });

        });

    }
};

const mutations = {

};

export default {
    state,
    actions,
    mutations
};
